export const getNaverDirectionUrl = (externalId?: string) => {
  if (!externalId) return "";
  return `https://m.place.naver.com/share?id=${externalId}&tabsPath=%2Fhome&appMode=detail`;
};
